// Added by Sejune Oh on 2019-08-29
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { GetQueryReturn } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { NodeElementProps, NodeScoreType, GetCapascoresArgProps } from './NodeStore'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqGetNodes = async (path: string = '') => {
    return await axios.get<GetQueryReturn<NodeElementProps>>(`/v1/mgmt/nodes?${path}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResCreateNodeProps extends NodeElementProps { }
export const reqCreateNode = async (nodeElementProps: NodeElementProps) => {
    return await axios.post<ResCreateNodeProps>(`/v1/mgmt/nodes`, { ...nodeElementProps })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResAppSessionCapaProps {
    license_max: number
    node_capa_max: number
    cur: number
}
export const reqAppSessionCapa = async () => {
    return await axios.get<ResAppSessionCapaProps>(`/v1/mgmt/nodes-capa/app-session`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResGetCapascores {
    items: Array<NodeElementWithCapacityProps>
    request: GetCapascoresArgProps
}
export interface NodeElementWithCapacityProps extends NodeElementProps {
    used_score: NodeScoreType
}
export const reqGetCapascores = async (path: string) => {
    return await axios.get<ResGetCapascores>(`/v1/mgmt/nodes-capa/scores?${path}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResDetectAvailableNode {
    available: boolean
    node_key: string
    limited_by_license: boolean
    nodes_count: number
    score: {
        cpu: number
        gpu: number
    }
    used_score: {
        cpu: number
        gpu: number
    }
    whole_score: {
        cpu: number
        gpu: number
    }
    used_whole_score: {
        cpu: number
        gpu: number
    }
}
export const reqDetectAvailableNode = async (path: string) => {
    return await axios.get<ResDetectAvailableNode>(`/v1/mgmt/nodes-capa/detect-available-node?${path}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResGetNodeProps extends NodeElementProps { }
export const reqGetNode = async (id: string) => {
    return await axios.get<ResGetNodeProps>(`/v1/mgmt/nodes/${id}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqDeleteNode = async (id: string) => {
    return await axios.delete(`/v1/mgmt/nodes/${id}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResUpdateNodeProps extends NodeElementProps { }
export const reqUpdateNode = async (id: string, nodeElementProps: NodeElementProps) => {
    return await axios.put<ResUpdateNodeProps>(`/v1/mgmt/nodes/${id}`, {
        ...nodeElementProps,
    })
}

export const ReqCheckAssignedDS = async (id: string) => {
    return await axios.get(`/v1/mgmt/nodes/${id}/check-referenced`)
}